import { render, staticRenderFns } from "./ProportionPrepaid.vue?vue&type=template&id=39d4cdae&scoped=true"
import script from "./ProportionPrepaid.vue?vue&type=script&lang=js"
export * from "./ProportionPrepaid.vue?vue&type=script&lang=js"
import style0 from "./ProportionPrepaid.vue?vue&type=style&index=0&id=39d4cdae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d4cdae",
  null
  
)

export default component.exports